module.exports = __webpack_public_path__ + "static/media/36-2.e165d820.mp3";